export default __webpack_public_path__ + "static/media/paysys-white.46d8840c.svg";